/*
    rxConnect® ePrescribing Middleware by HITORI.
    © 2025 HITORI (Melbourne, Australia). All rights reserved.
    Website: https://hitori-inc.com

    This software is proprietary and confidential.
    Unauthorised copying, distribution, or modification of this file, via any medium, is strictly prohibited.

    Styling and theming by licensed third parties is permitted under applicable agreements.
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
